import {
  BagWidget,
  ChatWidgetText,
  isSafeWidgetUrl,
} from "../../../Helper/ChatWidget";
import {
  Button,
  Card,
  Foot,
  openWidgetUrl,
  Thumb,
} from "../ChatWidgetPrimitives";
import "./BagCard.scss";

/** 14 Bag: what's in the cart, codes applied, the total, Checkout. */
export const BagCard = ({
  widget,
  text,
}: {
  widget: BagWidget;
  text: ChatWidgetText;
}) => {
  const items = widget.items ?? [];
  const count = items.reduce((sum, item) => sum + (Number(item.qty) || 0), 0);
  const title = widget.title ?? text("widgetBag");
  return (
    <Card className="cw-bag" label={title}>
      <div className="cw-row cw-pad cw-bag-head">
        <span className="cw-h">{title}</span>
        <span className="cw-muted cw-sm">
          {count === 1
            ? text("widgetItemCountOne")
            : text("widgetItemCount", { n: count })}
        </span>
      </div>
      <ul className="cw-bag-items">
        {items.map((item, index) => (
          <li className="cw-line" key={index}>
            <Thumb image={item.image} />
            <span className="cw-stack cw-grow">
              <span className="cw-medium">{item.title}</span>
              <span className="cw-muted cw-sm">
                {[item.subtitle, text("widgetQty", { n: item.qty })]
                  .filter(Boolean)
                  .join(" · ")}
              </span>
            </span>
            <span className="cw-num cw-strong">{item.price}</span>
          </li>
        ))}
      </ul>
      <div className="cw-sep cw-bag-sep" />
      <dl className="cw-bag-sums cw-sm">
        <div className="cw-row">
          <dt className="cw-muted">{text("widgetSubtotal")}</dt>
          <dd className="cw-num">{widget.subtotal}</dd>
        </div>
        {(widget.discounts ?? []).map((discount, index) => (
          <div className="cw-row" key={index}>
            <dt className="cw-muted">{discount.label}</dt>
            <dd className="cw-num cw-bag-discount">{discount.amount}</dd>
          </div>
        ))}
        {widget.delivery && (
          <div className="cw-row">
            <dt className="cw-muted">{text("widgetDelivery")}</dt>
            <dd>{widget.delivery}</dd>
          </div>
        )}
      </dl>
      <div className="cw-row cw-bag-total">
        <span className="cw-strong">{text("widgetTotal")}</span>
        <span className="cw-num cw-bag-total-amount">{widget.total}</span>
      </div>
      {isSafeWidgetUrl(widget.checkoutUrl) ? (
        <Foot>
          <Button onClick={() => openWidgetUrl(widget.checkoutUrl)}>
            {text("widgetCheckout")}
          </Button>
        </Foot>
      ) : (
        <div className="cw-bag-end" />
      )}
    </Card>
  );
};
